import { render, staticRenderFns } from "./AskQuestionCta.vue?vue&type=template&id=31a09106"
import script from "./AskQuestionCta.vue?vue&type=script&lang=js"
export * from "./AskQuestionCta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports